import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StorySelection from './StorySelection';

const StorySelector = ({ storyTemplates = [], onSelect }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // Add defensive check
  if (!storyTemplates || !Array.isArray(storyTemplates) || storyTemplates.length === 0) {
    return (
      <div className="max-w-4xl mx-auto p-8 bg-white rounded-xl shadow-lg">
        <h2 className="text-xl font-bold text-red-500">
          No story templates available
        </h2>
        <p className="mt-2">
          Please check back later or contact support.
        </p>
      </div>
    );
  }

  if (selectedTemplate) {
    return (
      <StorySelection
        template={selectedTemplate}
        onSelectStory={(title) => onSelect(selectedTemplate.id, title)}
        onBack={() => setSelectedTemplate(null)}
      />
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
          Choose Your Story Style
        </h1>
        <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
          Each style offers a unique way to tell your story. Pick the one that sparks your imagination!
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {storyTemplates.map((template) => (
          <div
            key={template.id}
            className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
            onClick={() => setSelectedTemplate(template)}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            <div className="relative p-6">
              <div className="flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-500 text-white text-3xl mb-4 mx-auto transform group-hover:scale-110 transition-transform duration-300">
                {template.emoji}
              </div>

              <h2 className="text-2xl font-bold text-center text-gray-900 mb-2">
                {template.title}
              </h2>

              <p className="text-center text-gray-600 mb-4">
                {template.subtitle}
              </p>

              <p className="text-sm text-gray-500 text-center">
                {template.description}
              </p>

              <div className="mt-6 flex justify-center">
                <button className="px-6 py-2 bg-yellow-400 text-gray-900 rounded-full font-medium hover:bg-yellow-500 transition-colors duration-300 transform group-hover:scale-105">
                  Choose Style
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

StorySelector.propTypes = {
  storyTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      emoji: PropTypes.string.isRequired,
      example_stories: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ),
  onSelect: PropTypes.func.isRequired
};

StorySelector.defaultProps = {
  storyTemplates: []
};

export default StorySelector;